export class ResponseData {
    status: boolean;
    message: string;
    result: any;

    constructor(status: boolean, message: string, result: any) {
        this.status = status;
        this.message = (typeof message !== 'undefined' && message !== '') ? message : '';
        this.result = result;
    }
}

export class PaginatedData {
    registers: any;
    registersTotal: number;
    page: number;
    pageSize: number;
    pageTotal: number;

    constructor(registers: any, total: number, pageSize: number, pages: number, page: number) {
        this.registers = registers;
        this.registersTotal = total;
        this.page = page;
        this.pageSize = pageSize;
        this.pageTotal = pages;
    }
}

export class MetaData {
    public id: number;
    public name: string;

    constructor(id?: number, name?: string) {
        this.id = (typeof id !== 'undefined' && id > 0) ? id : 0;
        this.name = (typeof name !== 'undefined' && name !== '') ? name : '';
    }

    configData(parameters: any): MetaData{
        this.id = parameters.id;
        this.name = parameters.nombre;

        return this;
    }
}

export class MenuItem {
    public menu?: string;
    public icon?: string;
    public route?: string;
    public title?: string;
    public action?: () => void;
}

export class NavbarConfig {
    public title: string;
    public navbarShow: boolean;
    public navbarDouble: boolean;
    public menuButtonShow: boolean;

    constructor() {
        this.title = 'IpTel';
        this.navbarShow = true;
        this.navbarDouble = false;
        this.menuButtonShow = true;
    }

    public onDefaultActionButton(): void {
        console.log('Action Button was pressed');
    }

    // Pseudo-Builder design pattern implementation (simplified maybe a little too much)
    withTitle(value: string): NavbarConfig {
        this.title = value;
        return this;
    }

    navbarDisplay(value: boolean): NavbarConfig {
        this.navbarShow = value;
        return this;
    }

    navbarHasDouble(value: boolean): NavbarConfig {
        this.navbarDouble = value;
        return this;
    }

    menuButtonDisplay(value: boolean): NavbarConfig {
        this.menuButtonShow = value;
        return this;
    }
}

/**
 * This enum contains the possible events that can be sent or be obtained
 * from the android app.
 */
export enum PlatformEvent {
    GET_DEVICE_ID = 'GetDeviceId',
    IMAGE_READ = 'ReadImage',
    IMAGE_TAKE = 'TakePicture',
    IMAGE_FRAGMENT = 'GetImageFragment',
    CLOSE_APP = 'CloseApp',
    GET_GPS = 'GetGPS',
    GO_BACK = 'GoBack',
    ERROR = 'Error'
}
